module.exports = __webpack_public_path__ + "6f4be43d38c28d083337ac9e4f752425.png";